import { LngLat } from 'maplibre-gl';
import type { CoordinateDTO } from '@ui/shared/util-api';

export const coordinatesToLngLat = (coordinates: CoordinateDTO): LngLat =>
    new LngLat(coordinates.longitude, coordinates.latitude);
